import { render, staticRenderFns } from "./WorkItemDetailsDialog.vue?vue&type=template&id=69fb34d7&scoped=true"
import script from "./WorkItemDetailsDialog.vue?vue&type=script&lang=js"
export * from "./WorkItemDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkItemDetailsDialog.vue?vue&type=style&index=0&id=69fb34d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fb34d7",
  null
  
)

export default component.exports